import { render, staticRenderFns } from "./DataTableDataLayout.vue?vue&type=template&id=58841b8a&scoped=true&"
import script from "./DataTableDataLayout.vue?vue&type=script&lang=js&"
export * from "./DataTableDataLayout.vue?vue&type=script&lang=js&"
import style0 from "./DataTableDataLayout.vue?vue&type=style&index=0&id=58841b8a&scoped=true&lang=css&"
import style1 from "../../assets/style/base.css?vue&type=style&index=1&id=58841b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58841b8a",
  null
  
)

export default component.exports